module.exports = __webpack_public_path__ + "static/media/mobey-bill-slash.0c46f387.svg";